import type { Tokens } from '../../../../theming/types'
import { styles } from '../../../../utilities'

const badgeStyles = {
  badge: {
    height: '8px',
    width: '8px',
  },
}

export default (config: { tokens: Tokens }) => {
  const { tokens } = config
  return {
    default: {
      badge: {
        backgroundColor: tokens.messageBgColorAlert,
        border: `2px solid ${tokens.borderColorEmphasisInverse}`,
        boxSizing: 'content-box',
        borderRadius: '50%',
        display: 'inline-flex',
      },
    },

    sizeXxlarge: badgeStyles,
    sizeXlarge: badgeStyles,
    sizeLarge: badgeStyles,
    sizeMedium: badgeStyles,
    sizeSmall: badgeStyles,
    sizeXsmall: badgeStyles,

    hidden: styles.visuallyHidden,
  } as const
}
